// =====================================================
// TYPES: DISCOUNT
// Description: Types TypeScript pour les réductions
// =====================================================

export interface Discount {
  id: string;
  name: string; // Nom de la réduction
  amount: number; // Montant en EUR
  status: string; // Active, Inactive
  description?: string; // Description optionnelle
  created_at: string; // Date d'émission (auto)
  updated_at: string;
}

export interface CreateDiscountDto {
  name: string;
  amount: number;
  status?: string;
}

export interface UpdateDiscountDto {
  name?: string;
  amount?: number;
  status?: string;
}

// Statuts disponibles
export const DISCOUNT_STATUSES = ['Active', 'Inactive'] as const;

export type DiscountStatus = (typeof DISCOUNT_STATUSES)[number];
